export default {
  SDKAppID: 1400188366,
  CallTimeout: 30
}
